import { FC } from "react";

interface MouseScrollIndicatorProps {
  className?: string;
  scrollTo?: number; // Optional target scroll position
  smoothScroll?: boolean; // Optional smooth scrolling toggle
}

const MouseScrollIndicator: FC<MouseScrollIndicatorProps> = ({
  className = "",
  scrollTo,
  smoothScroll = true,
}) => {
  const handleClick = () => {
    if (scrollTo !== undefined) {
      // Scroll to specific position
      window.scrollTo({
        top: scrollTo,
        behavior: smoothScroll ? "smooth" : "auto",
      });
    } else {
      // Default: scroll down one viewport height
      const scrollAmount = window.innerHeight;
      window.scrollTo({
        top: window.pageYOffset + scrollAmount,
        behavior: smoothScroll ? "smooth" : "auto",
      });
    }
  };

  return (
    <div
      className={`flex justify-center items-center ${className}`}
      onClick={handleClick}
    >
      <div className="relative w-5 h-8 border-2 border-white rounded-full cursor-pointer flex justify-center">
        <span className="block w-1 h-1.5 bg-white rounded-full animate-scrollWheel" />
      </div>
    </div>
  );
};

export default MouseScrollIndicator;
